export default "__VITE_ASSET__tct4bQuH__"